import { ActionPlanIntervention } from '@/api/generated-catch-backend/model';
import NextArrow from '@/app/components/questionnaireV2/icons/next-arrow';
import icons from '@/assets/icons';

type RecommendedActionCard = {
  action: ActionPlanIntervention;
  onClick?: () => void;
};
// Helper function to render action icon
const renderActionIcon = (action: ActionPlanIntervention) => {
  if (action.iconAsset?.url) {
    return <img src={action.iconAsset.url} alt={action.iconAsset.alt || action.title} className="h-auto w-[36px]" />;
  }

  // Default to biomarkers-alt-1 icon when no specific icon is available
  const iconSrc = icons['biomarkers-alt-1'];
  return <img src={iconSrc} alt={action.title} className="h-auto w-[36px]" />;
};

export const RecommendedActionCard = ({ action, onClick }: RecommendedActionCard) => {
  const isClickable = !!onClick;
  return (
    <button
      key={action.id}
      className="w-[295px] rounded-[10px] border border-[#ededed] bg-white transition-all duration-200 hover:-translate-y-px hover:opacity-80 active:translate-y-0 md:w-[744px]"
      onClick={onClick}
      disabled={!isClickable}
      aria-disabled={!isClickable}
      style={{
        cursor: isClickable ? 'pointer' : 'default',
      }}
      data-testid={`recommended-action-card-${action.id}`}
    >
      <div className="flex items-center gap-3 p-4">
        {/* Icon on the left - vertically centered */}
        <div className="flex-shrink-0">{renderActionIcon(action)}</div>

        {/* Content in the middle */}
        <div className="flex-1 items-start text-left">
          <h3 className="text-[14px] leading-[1.5] font-bold text-[#101010]">{action.title}</h3>
          <p className="mt-1 text-[12px] leading-[1.4] text-[#606060]">
            {action.affectedCancersCount && action.affectedCancersCount > 1
              ? `Reduce your risk for ${action.affectedCancersCount} cancers`
              : action.affectedCancersCount && action.affectedCancersCount === 1
                ? `Reduce your risk for ${action.affectedCancersCount} cancer`
                : 'Reduce your risk for cancer'}
          </p>
        </div>

        {/* Arrow on the right - vertically centered */}
        <div className={`arrow-button flex-shrink-0 ${!isClickable ? 'hidden' : ''}`}>
          <div className="arrow-icon-container">
            <NextArrow />
          </div>
        </div>
      </div>
    </button>
  );
};
